import React from 'react';
import { IBaseAction } from '@models/actions/IBaseAction';
import { DocBaseActionExecutor } from '@organisms/actions/DocBaseActionExecutor';
import { ModalSize } from '@/types/ModalSize';
import { IVoteWithSignProps } from './IVoteWithSignProps';
import { VoteQuestionWithSignExecutorModal } from './VoteQuestionWithSignExecutorModal';

export class VoteQuestionWithSignExecutor extends DocBaseActionExecutor {
    private _modalProps?: IVoteWithSignProps;

    runInternal = (
        objId: string,
        parentId: string | undefined,
        action: IBaseAction,
        rowData?: any,
        completeHandler?: (isSucceed: boolean) => void,
        modalSize?: ModalSize | null,
    ) => {
        this._modalProps = {
            docId: objId ?? '',
            action: action,
            userType: action.options?.userType ?? 'secretary',
            participantVote: action.options?.participantVote,
            okButtonText: action.options?.okButtonText ?? 'ОК',
            cancelButtonText: action.options?.cancelButtonText ?? 'Отмена',
            modalSize: modalSize ?? action.options?.modalSize ?? 'xl',
            completeHandler: completeHandler,
        };
    };

    visualElementInner = () => {
        return this._modalProps ? <VoteQuestionWithSignExecutorModal {...this._modalProps} /> : <div />;
    };
}
